module.exports = __webpack_public_path__ + "dbe1763f68f49f151a68d4ec507995ed.pdf";